export const formatLocation = (location: string) => {
    const commaIndex = location.indexOf(',');
    if (commaIndex === -1) {
        return <>{location}</>;
    }
    const firstPart = location.substring(0, commaIndex).trim();
    const secondPart = location.substring(commaIndex + 1).trim();
    return (
        <>
            {firstPart}
            <br />
            {secondPart}
        </>
    );
};

export const formatEventDateTime = (startTime: string, endTime: string, split: boolean = false) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const dayOfWeek = start.toLocaleDateString('en-US', { weekday: 'long' });
    const month = start.toLocaleDateString('en-US', { month: 'short' });
    const day = start.getDate();
    const startTimeStr = start.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
    const endTimeStr = end.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short'
    });
    if (split) {
        return (<>
            {dayOfWeek}, {month} {day}
            <br />
            {startTimeStr} to {endTimeStr}
        </>);
    } else {
        return `${dayOfWeek}, ${month} ${day}, ${startTimeStr} to ${endTimeStr}`
    }
};